import type { HTMLAttributes } from 'react';
import { IconButton, type IconButtonProps } from '@trg/tlw-ui-component';
import { tlwTwMerge } from '@trg/utils';

const socialMedias: Pick<IconButtonProps, 'icon' | 'href'>[] = [
  {
    href: 'https://www.facebook.com/17DIY',
    icon: 'SocialFb',
  },
  {
    href: 'https://www.youtube.com/channel/UCV2Y0KrSXs_hGu8pjrODSSw',
    icon: 'SocialYoutube',
  },
  {
    href: 'https://lin.ee/JkiIG22',
    icon: 'SocialLine',
  },
];

export type SocialMediaProps = Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export function SocialMedia({ className, ...props }: SocialMediaProps) {
  return (
    <div
      className={tlwTwMerge(
        'tlw-flex tlw-flex-wrap tlw-items-center tlw-justify-start tlw-gap-4 lg:tlw-gap-6',
        className
      )}
      {...props}
    >
      {socialMedias.map((item, index) => (
        <IconButton
          key={`${item.href}_${index}`}
          className="tlw-text-txt-black tlw-border-gray-400 tlw-p-3 tlw-text-2xl"
          outline
          {...item}
        />
      ))}
    </div>
  );
}
